module.exports = __webpack_public_path__ + "static/img/case2.255faf75.png";